import React, { useEffect, useState } from 'react';
import { Box, Divider, Slide } from '@mui/material';
import { useTicketsSelected } from '@/store';
import EventHome from './EventHome';
import EventInfo from '@/templates/plus/sections/EventNav/EventInfo';
import EventTickets from '@/templates/plus/sections/EventNav/EventTickets';
import FooterSummary from '@/templates/plus/sections/FooterSummary';

function EventNav({
  view,
  onCloseEventInfo,
  onReadMore,
  onTicketCategorySelected,
}) {
  const [show, setShow] = useState(false);
  const { hasTickets } = useTicketsSelected();

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
      }}
    >
      <Slide direction="up" in={view === 'info'} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'scroll',
          }}
        >
          <EventInfo onClose={onCloseEventInfo} sx={{ pr: 2 }} />
        </Box>
      </Slide>
      <Slide
        direction="left"
        in={view === 'summary'}
        mountOnEnter
        unmountOnExit
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'scroll',
          }}
        >
          <EventTickets onBack={onCloseEventInfo} />
        </Box>
      </Slide>
      <EventHome
        onReadMore={onReadMore}
        onTicketCategorySelected={onTicketCategorySelected}
      />
      {show && hasTickets && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            background: '#FFF',
          }}
        >
          <Box
            sx={{
              mr: '24px',
              ml: '24px',
            }}
          >
            <Divider />
            <FooterSummary />
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default EventNav;
